import { IoMdClose } from "react-icons/io";
import { Button, Card, CardBody, Col, Label, Modal, ModalBody, Table, ModalHeader, Row } from "reactstrap";
import { additionalSvg, customRound, proSvg } from "../constants/constant";
import { getRequest, getRequestForDownload, postRequest } from "../../../../hooks/axiosClient";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../../BuildProject.css';
import { useEffect, useRef, useState } from "react";
import CommonDropdown from "../../../../components/common/CommonDropdown";
import jsPDF from "jspdf";

const ProPinModal = ({
    isOpen,
    toggle,
    totalPinsUsed,
    planDetails,
    addCardDetails,
    projectSettings
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size='sm' zIndex={2001} style={{ zIndex: '999999 !important', color: '#000' }} centered>
            <ModalHeader style={{ padding: '25px 25px 15px 25px', fontSize: '1.5rem' }}>
                <div className='d-flex justify-space-between'>
                    <span>
                        You've Hit Your Limit!
                    </span>
                    <div className='ml-2  rounded-circle payment-close-btn' onClick={() => toggle()} >
                        <IoMdClose fontSize={15} />
                    </div>
                </div>
            </ModalHeader>
            <ModalBody style={{ padding: '0px 32px 32px 32px', fontSize: '0.875rem', fontWeight: '500' }}>
                <Card >
                    <p>You've reached the maximum number of pins for your current plan:</p>
                    <ul className='ulStyles' style={{ marginTop: '10px' }}>
                        <li>
                            <span className={`${totalPinsUsed?.used_locations == totalPinsUsed?.total_locations ? 'red' : ''}`}>{totalPinsUsed?.used_locations}</span>/{totalPinsUsed?.total_locations} Location Pins
                        </li>
                        <li>
                            <span className={`${totalPinsUsed?.used_products == totalPinsUsed?.total_products ? 'red' : ''}`}>{totalPinsUsed?.used_products}</span>/{totalPinsUsed?.total_products} Product Pins
                        </li>
                    </ul>
                    <p style={{ marginTop: '10px' }}>
                        {((planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0)) ? 'Please upgrade your plan to increase your total pin limit.' : 'Please purchase additional pins to increase your total pin limit.'}
                    </p>

                    <Card className="cardContainer">

                        <CardBody className='greycard'>
                            <div className="svgContainer">
                                {((planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0)) ? proSvg : additionalSvg}

                            </div>
                            <h1 style={{ fontSize: '1.5rem', fontWeight: '600' }}>{(planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0) ? 'Pro' : (planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 1 && planDetails?.plan?.additional_expired == 0) ? 'Additional' : 'Additional +'}</h1>
                            <ul className='ulStyles'>
                                <li>
                                    {
                                        (planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0)
                                            ?
                                            `$${customRound(((planDetails?.plan?.basic_cost) - ((planDetails?.plan?.basic_cost) * (planDetails?.plan?.discount / 100))), 2)}`
                                            :
                                            `$${customRound(((planDetails?.plan?.additional_cost) - ((planDetails?.plan?.additional_cost) * (planDetails?.plan?.discount / 100))), 2)}`} / month
                                </li>
                                <li>
                                    {(planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0) ? `${planDetails?.plan?.basic_location_pins}` : `${planDetails?.plan?.additional_location_pins}`}   Additional Location Pins
                                </li>
                                <li>
                                    {(planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0) ? `${planDetails?.plan?.basic_product_pins}` : `${planDetails?.plan?.additional_product_pins}`}  Additional Product Pins
                                </li>
                            </ul>
                        </CardBody>
                        <Button className={` ${(planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0) ? 'btn-warning ' : 'btn-successs'}`}
                            onClick={() => {
                                if ((planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0) && projectSettings?.status == 0) {
                                    toast.warning('Project is inactive! To upgrade to the pro plan, please activate your project.')
                                } else {
                                    addCardDetails(planDetails?.plan)
                                }
                            }
                            }
                        >
                            Proceed to Payment
                        </Button>
                    </Card>
                </Card >
            </ModalBody>
        </Modal>
    )
}

const GenerateQrModal = ({
    isOpen,
    toggle,
    projectSettings,
    filteredData,
}) => {
    const [loading, setLoading] = useState(false);
    const [beaconOptions, setBeaconOptions] = useState([]);
    const [beaconValue, setBeaconValue] = useState({});
    const canvasRef = useRef(null);

    const onChangeBeacon = (e) => {
        setBeaconValue(e)
    }

    useEffect(() => {
        if (isOpen == true) {
            setBeaconValue({})
            // console.log(filteredData, 'filteredData')
            const sortedData = filteredData.filter(item => item.position !== null);
            setBeaconOptions((prev) => {
                return sortedData.map((el) => ({ ...el, value: el.enc_id, label: el.beacon_name }))
            });
        }
    }, [isOpen])

    const generateQrcode = async (row, type) => {
        setLoading(true);
        try {
            DownloadPdf(row,type)
            // const response = await getRequestForDownload(`generate-qr/${row?.enc_id}/${type}`);
            // console.log(response)
            // const dataRes = response.data;
            // const blob = new Blob([dataRes], {
            //     type: "application/pdf",
            // });
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // const pdfName = row?.beacon_name
            // link.setAttribute("download", `${pdfName}.pdf`);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            // toast.success('QR Code beacon poster generated successfully.');
            // createNotification('success', 'Student pin details downloaded successfully.', 'filled');
        } catch (error) {
            console.log(error)
            if (error.response.status === 400) {
                toast.error("Please publish the project to generate QR Code Beacon.")
            }
            setLoading(false)
        }
        // finally {
        //     setTimeout(() => {
        //         setLoading(false)
        //     }, 3000);
        // }
    }

    const deleteQrPng = async (imageUrl) => {
        try {
          const response = await postRequest(`delete-qr`,{url:imageUrl});
        //   console.log(response);
        } catch (error) {
          console.log(error);
        }
      }

    const DownloadQrcodeAsPng = async (row) => {
    setLoading(true);
        try {
        const response = await getRequest(`download-qr/${row?.enc_id}`);
        // console.log(response);
        const dataRes = response.data;
        downloadQrPng(dataRes, row)
        } catch (error) {
        // console.log(error);
        if (error.response.status === 400) {
            toast.error("Please publish the project to generate QR Code Beacon.")
        }
        } finally {
        setTimeout(() => {
            setLoading(false)
        }, 3000);
        }
    }

    const downloadQrPng = async (responseData, row) => {
        try {
            const imageUrl = responseData?.url;
            if (!imageUrl) {
                toast.error("Image URL not found.");
                return;
            }
    
            const imageResponse = await fetch(imageUrl);
            const blob = await imageResponse.blob();
    
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const imageName = row?.beacon_name || "QRCode"; 
            link.setAttribute("download", `${imageName}.png`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
    
            toast.success("QR Code image downloaded successfully.");
            deleteQrPng(imageUrl)

        } catch (error) {
            console.error("Error downloading the QR Code:", error);
            toast.error("Failed to download QR Code.");
        }
    }; 
    
    const DownloadPdf = async (row, type) => {
        const pdfSizes = {
            1: { width: 595, height: 842, format: 'a4' },
            2: { width: 842, height: 1191, format: 'a3' },
            3: { width: 1684, height: 2382, format: [1684, 2382] }
        };
        const a4Size = pdfSizes[1];
        const targetSize = pdfSizes[type];

        try {
            const url = `generate-qr/${row?.enc_id}`;
            const response = await getRequest(url);
            const data = response?.data?.data;

            const beacon_template = JSON.parse(data?.beacon_template);
            const beacon_name = data?.beacon_name;
            const new_qr = data?.qrcodePath;

            if (!beacon_template || typeof beacon_template !== 'object') {
                console.error("Invalid or missing beacon_template:", beacon_template);
                return;
            }

            const canvasElement = canvasRef.current;
            if (!canvasElement) {
                console.error("Canvas ref not found.");
                return;
            }

            const canvas = new fabric.Canvas(canvasElement, {
                width: a4Size.width,
                height: a4Size.height,
                backgroundColor: '#ffffff',
            });

            fabric.Image.fromURL(new_qr, (newImg) => {
                // canvas.loadFromJSON(beacon_template, () => {
                //     canvas.renderAll();

                //     removeTaintedGroups(canvas);

                //     canvas.getObjects().forEach((obj) => {

                //         if (obj.name === "qr_container" && obj.type === "group") {
                //             const groupObjects = obj.getObjects();
                //             const oldQrImage = groupObjects.find(
                //                 (child) => child.name === "qrimage" && child.type === "image"
                //             );

                //             if (oldQrImage) {
                //                 const renderedWidth = oldQrImage.width * oldQrImage.scaleX;
                //                 const renderedHeight = oldQrImage.height * oldQrImage.scaleY;

                //                 const newScaleX = renderedWidth / newImg.width;
                //                 const newScaleY = renderedHeight / newImg.height;

                //                 newImg.set({
                //                     left: oldQrImage.left,
                //                     top: oldQrImage.top,
                //                     scaleX: newScaleX,   
                //                     scaleY: newScaleY,
                //                     angle: oldQrImage.angle,
                //                     originX: oldQrImage.originX,
                //                     originY: oldQrImage.originY,
                //                     name: oldQrImage.name,
                //                     selectable: oldQrImage.selectable,
                //                 });

                //                 obj.remove(oldQrImage);
                //                 obj.add(newImg);
                //                 obj.addWithUpdate();
                //             }
                //         }

                //         if (obj.name === "qr_container" && obj.type === "textbox") {
                //             const originalCenter = obj.getCenterPoint();
                //             obj.text = applyMatchingCase(obj.text, beacon_name);
                //             obj.set({
                //                 originX: 'center',
                //                 originY: 'center',
                //                 left: originalCenter.x,
                //                 top: originalCenter.y,
                //             });
                //         }

                //         if (obj.objectLayoutType === "layout-boundary" && obj.type === "group") {
                //             obj.set({
                //                 shadow: null,
                //                 stroke: null,
                //                 strokeWidth: 0,
                //                 padding: 0, 
                //                 borderScaleFactor: 0
                //             });
                //         }
                //     });

                //     canvas.renderAll();

                //     const backgroundObject = canvas.getObjects().find(
                //         (obj) => obj.objectLayoutType === "layout-boundary" && obj.type === "group"
                //     );

                //     if (!backgroundObject) {
                //         console.error("❌ No layout-boundary group found.");
                //         return;
                //     }

                //     backgroundObject.setCoords();
                //     canvas.renderAll();

                //     const bounds = backgroundObject.getBoundingRect(true, true);

                //     const objectsInside = canvas.getObjects().filter((obj) => {
                //         if (obj === backgroundObject) return true;
                //         const objBounds = obj.getBoundingRect();
                //         return !(
                //             objBounds.left + objBounds.width < bounds.left ||
                //             objBounds.left > bounds.left + bounds.width ||
                //             objBounds.top + objBounds.height < bounds.top ||
                //             objBounds.top > bounds.top + bounds.height
                //         );
                //     });

                //     const tempCanvas = new fabric.StaticCanvas(null, {
                //         width: bounds.width,
                //         height: bounds.height,
                //         backgroundColor: '#ffffff',
                //     });

                //     let cloneCount = 0;
                //     const total = objectsInside.length;
  
                //     objectsInside.forEach((obj) => {
                //         obj.clone((cloned) => {
                //             cloned.set({
                //                 left: cloned.left - bounds.left,
                //                 top: cloned.top - bounds.top,
                //             });
                            
                //             if (obj.objectLayoutType === "layout-boundary") {
                //                 tempCanvas.insertAt(cloned, 0);  
                //             } else {
                //                 tempCanvas.add(cloned);  
                //             }

                //             cloneCount++;

                //             if (cloneCount === total) {
                //                 tempCanvas.renderAll();
                //                 const scaleX = targetSize.width / a4Size.width;
                //                 const scaleY = targetSize.height / a4Size.height;
                //                 const scale = Math.min(scaleX, scaleY);
                //                 exportCanvasAsPNG(tempCanvas, beacon_name, targetSize, scale);
                //             }
                //         });
                //     });
                // });
            
                canvas.loadFromJSON(beacon_template, () => {
                    canvas.renderAll();
 
                    const layoutBoundary = canvas.getObjects().find(
                        (obj) => obj.objectLayoutType === "layout-boundary"
                    );

                    if (!layoutBoundary) {
                        console.error("❌ No layout-boundary found.");
                        return;
                    }

                    // removeTaintedGroups(canvas);

                    if (layoutBoundary.type === "group") {
                        handleNewTemplate(newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size);
                    } else {
                        handleOldTemplate(newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size);
                    }
                });
            
            }, { crossOrigin: 'anonymous' });

        } catch (error) {
            console.error("QR fetch error:", error);
            toast.error(error?.response?.data?.message || 'Something went wrong.')
        }
    };

    const processExport = (bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size) => {
        const objectsInside = canvas.getObjects().filter((obj) => {
        if (obj === layoutBoundary) return true;

        const objBounds = obj.getBoundingRect();
            return !(
                objBounds.left + objBounds.width < bounds.left ||
                objBounds.left > bounds.left + bounds.width ||
                objBounds.top + objBounds.height < bounds.top ||
                objBounds.top > bounds.top + bounds.height
            );
        });

        const tempCanvas = new fabric.StaticCanvas(null, {
            width: bounds.width,
            height: bounds.height,
            backgroundColor: "#ffffff"
        });

        let cloneCount = 0;
        const total = objectsInside.length;

        objectsInside.forEach((obj) => {
            obj.clone((cloned) => {
                cloned.set({
                    left: cloned.left - bounds.left,
                    top: cloned.top - bounds.top
                });

                if (obj.objectLayoutType === "layout-boundary") {
                    tempCanvas.insertAt(cloned, 0);
                } else {
                    tempCanvas.add(cloned);
                }

                cloneCount++;

                if (cloneCount === total) {
                    tempCanvas.renderAll();

                    const scaleX = targetSize.width / a4Size.width;
                    const scaleY = targetSize.height / a4Size.height;
                    const scale = Math.min(scaleX, scaleY);

                    exportCanvasAsPNG(tempCanvas, beacon_name, targetSize, scale);
                }
            });
        });
    };

    // const handleNewTemplate = (newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size) => {
    //     canvas.getObjects().forEach((obj) => {
    //         if (obj.name === "qr_container" && obj.type === "group") {
    //             const oldQrImage = obj.getObjects().find(
    //             (child) => child.name === "qrimage" && child.type === "image"
    //             );

    //             if (oldQrImage) {
    //                 const renderedWidth = oldQrImage.width * oldQrImage.scaleX;
    //                 const renderedHeight = oldQrImage.height * oldQrImage.scaleY;

    //                 newImg.set({
    //                     left: oldQrImage.left,
    //                     top: oldQrImage.top,
    //                     scaleX: renderedWidth / newImg.width,
    //                     scaleY: renderedHeight / newImg.height,
    //                     angle: oldQrImage.angle,
    //                     originX: oldQrImage.originX,
    //                     originY: oldQrImage.originY,
    //                     name: oldQrImage.name,
    //                     selectable: oldQrImage.selectable
    //                 });

    //                 obj.remove(oldQrImage);
    //                 obj.add(newImg);
    //                 obj.addWithUpdate();
    //             }
    //         }

    //         if (obj.name === "qr_container" && obj.type === "textbox") {
    //             const originalCenter = obj.getCenterPoint();

    //             obj.text = applyMatchingCase(obj.text, beacon_name);
    //             obj.set({
    //                 originX: "center",
    //                 originY: "center",
    //                 left: originalCenter.x,
    //                 top: originalCenter.y
    //             });
    //         }

    //         if (obj.objectLayoutType === "layout-boundary" && obj.type === "group") {
    //             obj.set({
    //                 shadow: null,
    //                 stroke: null,
    //                 strokeWidth: 0,
    //                 padding: 0,
    //                 borderScaleFactor: 0
    //             });
    //         }
    //     });

    //     layoutBoundary.setCoords();
    //     const bounds = layoutBoundary.getBoundingRect(true, true);

    //     processExport(bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size);
    // };

    const handleNewTemplate = (newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size) => {  

        const replaceCompanyLogo = (logoObj, parentGroup = null) => { 
            return new Promise((resolve) => {
                fabric.Image.fromURL(projectSettings?.logo, (logoImg) => {
                    const renderedWidth = logoObj.width * logoObj.scaleX;
                    const renderedHeight = logoObj.height * logoObj.scaleY;

                    logoImg.set({
                        left: logoObj.left,
                        top: logoObj.top,
                        scaleX: renderedWidth / logoImg.width,
                        scaleY: renderedHeight / logoImg.height,
                        angle: logoObj.angle,
                        originX: logoObj.originX,
                        originY: logoObj.originY,
                        name: logoObj.name,
                        selectable: logoObj.selectable,
                    });

                    if (parentGroup) {
                        parentGroup.remove(logoObj);
                        parentGroup.add(logoImg);
                        parentGroup.addWithUpdate();
                    } else {
                        canvas.remove(logoObj);
                        canvas.add(logoImg);
                    }

                    canvas.renderAll();
                    resolve(); 
                }, { crossOrigin: 'anonymous' });
            });
        };
 
        const logoReplacePromises = [];

        canvas.getObjects().forEach((obj) => { 
            if (obj.name === "qr_container" && obj.type === "group") {
                const oldQrImage = obj.getObjects().find(
                    (child) => child.name === "qrimage" && child.type === "image"
                );

                if (oldQrImage) {
                    const renderedWidth = oldQrImage.width * oldQrImage.scaleX;
                    const renderedHeight = oldQrImage.height * oldQrImage.scaleY;

                    newImg.set({
                        left: oldQrImage.left,
                        top: oldQrImage.top,
                        scaleX: renderedWidth / newImg.width,
                        scaleY: renderedHeight / newImg.height,
                        angle: oldQrImage.angle,
                        originX: oldQrImage.originX,
                        originY: oldQrImage.originY,
                        name: oldQrImage.name,
                        selectable: oldQrImage.selectable
                    });

                    obj.remove(oldQrImage);
                    obj.add(newImg);
                    obj.addWithUpdate();
                }
            }

            if (obj.name === "company-log" && obj.type === "image") { 
                logoReplacePromises.push(replaceCompanyLogo(obj, null));
            }

            if (obj.name === "qr_container" && obj.type === "textbox") {
                const originalCenter = obj.getCenterPoint();
                obj.text = applyMatchingCase(obj.text, beacon_name);
                obj.set({
                    originX: "center",
                    originY: "center",
                    left: originalCenter.x,
                    top: originalCenter.y
                });
            }

            if (obj.objectLayoutType === "layout-boundary" && obj.type === "group") {
                obj.set({
                    shadow: null,
                    stroke: null,
                    strokeWidth: 0,
                    padding: 0,
                    borderScaleFactor: 0
                });
            }
        });
 
        Promise.all(logoReplacePromises).then(() => {
            layoutBoundary.setCoords();
            const bounds = layoutBoundary.getBoundingRect(true, true);
            processExport(bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size);
        });
    };

    const handleOldTemplate = (newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size) => {
        canvas.getObjects().forEach((obj) => {
        if (obj.name === "qrimage" && obj.type === "image") {
            newImg.set({
            left: obj.left,
            top: obj.top,
            scaleX: obj.scaleX,
            scaleY: obj.scaleY,
            angle: obj.angle,
            originX: obj.originX,
            originY: obj.originY,
            name: obj.name,
            selectable: obj.selectable,
            zIndex: obj.zIndex
            });

            canvas.remove(obj);
            canvas.add(newImg);
        }

        if (obj.name === "qrimage" && obj.type === "textbox") {
            const originalCenter = obj.getCenterPoint();
            obj.text = applyMatchingCase(obj.text, beacon_name);

            obj.set({
            originX: "center",
            originY: "center",
            left: originalCenter.x,
            top: originalCenter.y
            });
        }

        if (obj.objectLayoutType === "layout-boundary") {
            obj.set({
                shadow: null,
                stroke: null,
                strokeWidth: 0,
                padding: 0,
                borderScaleFactor: 0
            });
        }
        });

        layoutBoundary.setCoords();
        const bounds = layoutBoundary.getBoundingRect();

        processExport(bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size);
    };

    const applyMatchingCase = (templateText, inputText) => {
        if (!templateText) return inputText;
    
        const isUpperCase = templateText === templateText.toUpperCase();
        const isLowerCase = templateText === templateText.toLowerCase();
        const isCapitalized = /^[A-Z][a-z]/.test(templateText);
    
        if (isUpperCase) {
          return inputText.toUpperCase();
        } else if (isLowerCase) {
          return inputText.toLowerCase();
        } else if (isCapitalized) {
          return inputText
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase());
        }
    
        return inputText;
    };
    
    function exportCanvasAsPNG(canvas, name = 'beacon', size) {
        try {
            const multiplier = 3; 
            const dataURL = canvas.toDataURL({
                format: 'png',
                multiplier: multiplier,
                quality: 1,
            });
        
            const pdf = new jsPDF({
                // orientation: size.width > size.height ? 'landscape' : 'portrait',
                orientation: 'portrait',
                unit: 'pt',
                format: size.format
            });
        
            pdf.addImage(dataURL, 'PNG', 0, 0, size.width, size.height);
            pdf.save(`${name}-${size?.format}.pdf`);
            toast.success('QR Code beacon poster generated successfully.');
            setLoading(false);
        } catch (err) {
            console.error('Export failed:', err);
            toast.error("Export failed due to a tainted image.")
            // alert('Export failed due to a tainted image.');
            setLoading(false)
        }
    }
        
    function containsTaintedImage(obj) {
        if (obj.type === 'image') {
            const src = obj.getSrc?.();
            return src && !src.startsWith('data:image');
        }
        if (obj._objects) {
            return obj._objects.some(child => containsTaintedImage(child));
        }
        return false;
    }
    
    function removeTaintedGroups(canvas) {
        const objects = canvas.getObjects();
        for (let i = objects.length - 1; i >= 0; i--) {
            const obj = objects[i];
 
            if (obj.name === "qr_container" || obj.objectLayoutType === "layout-boundary") {
                continue;
            }

            if ((obj.type === 'group' || obj._objects) && containsTaintedImage(obj)) {
                // console.warn('Removing tainted group:', obj);
                // canvas.remove(obj);
            }
        }
        canvas.renderAll();
    }

    return (
        <>
            <Modal className="panel-header-canvas" isOpen={isOpen} zIndex={2001} toggle={toggle} style={{ zIndex: '999999 !important', maxWidth: '850px' }} centered>
                <canvas ref={canvasRef} style={{display:"none"}}/>
                <ModalHeader toggle={toggle} style={{ padding: '33px 32px 0px 32px' }} className="qr-downlaod-modal">
                    Generate QR Code Beacon Poster
                </ModalHeader>

                <ModalBody className="modalbody-padding" >
                    <Row className='mt-2 mb-3' >
                        <Col md={6}>

                            <Label className='form-labels'>Select QR Code Beacon</Label>
                            <CommonDropdown name='agent' options={beaconOptions} value={Object.keys(beaconValue).length > 0 ? beaconValue : null} onChange={(e) => { onChangeBeacon(e) }} />


                        </Col>
                    </Row>
                    <Row >
                        <Col md={12}>
                            <div className="mb-2">
                                <Label style={{ color: '#6a6d73', fontSize: '0.875rem', fontWeight: 'bold', marginTop: '11.48px' }}>{projectSettings?.project_name}</Label>
                            </div>
                        </Col>
                    </Row>
                    <Row >
                        <Col md={12}>
                            <Table className="custom-table">
                                <thead>
                                    <tr>
                                        <th className='theadStyle'>QR Code Beacon</th>
                                        <th className='theadStyle'>Print</th>
                                        {/* <th className='theadStyle'>Web</th> */}
                                        <th className='theadStyle'>QR</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {beaconValue?.beacon_name ? (
                                        // filteredData?.length > 0 ? (
                                        // filteredData?.map((item, index) => (
                                            <tr >
                                                <td>{beaconValue.beacon_name}</td>
                                                <td>
                                                    <div className='d-flex'>
                                                        <button className="btn btn-sm buttoninfo mr-2" onClick={() => generateQrcode(beaconValue, 1)}>A4</button>{" "}
                                                        <button className="btn btn-sm buttoninfo mr-2" onClick={() => generateQrcode(beaconValue, 2)}>A3</button>
                                                    </div>
                                                </td>
                                                {/* <td>
                                                    <button className="btn btn-sm buttoninfo" onClick={() => generateQrcode(beaconValue, 3)}>FHD</button>
                                                </td> */}
                                                <td>
                                                    <button className="btn btn-sm buttoninfo " onClick={() => DownloadQrcodeAsPng(beaconValue)}> Download</button>
                                                </td>
                                            </tr>
                                        // ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3">No data found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                        </Col>
                    </Row>
                    <Row className="mt-3 mb-3">
                        <Col md={12}>
                            <Button color="secondary" className="btn btnCancel float-right" onClick={toggle}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>

                </ModalBody>
                
            </Modal>
            {loading &&
                <Modal isOpen={true} size="sm" zIndex={2001} className="loading-modal" style={{ zIndex: '9999999 !important', maxWidth: '200px', backgroundColor: 'transparent' }} centered>
                    <ModalBody >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                            <div class="folder">
                                <span class="folder-tab"></span>
                                <div class="folder-icn">
                                    <div class="downloading">
                                        <span class="custom-arrow"></span>
                                    </div>
                                    <div class="bar-downld"></div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            }
        </>

    )
}

export {
    ProPinModal,
    GenerateQrModal,
}